import React, { useState } from "react";
import Checkbox from "../components/Checkbox";
import { store } from "../stores/Store";
import { Modal } from "../components/Modal";
import { observer } from "mobx-react-lite";
import { Button } from "../components/Button";
import './SummaryModal.scss';
import Input from "../components/Input";
import ErrorIcon from "../icons/ErrorIcon";
import { publicUrl } from "../utils/url";
import BedIcon from "../icons/BedIcon";
import GrayBox from "../components/GrayBox";
import Img from "../components/Img";
import { BoxHeader } from "../components/BoxHeader";
import { _t } from '../utils/Lang';


export function RenderIf({ condition, children }) {
    if (condition) return children;
    return null;
}

function ProductSubOptions({ product }) {
    if (!product?.options_configuration?.length) return null;
    return (
        <RenderIf condition={true}>
            {product.options_configuration.map((option) => {
                if (option.required === false) return null;
                return (
                    <span key={option.id} style={{ display: 'inline-block', paddingRight: 5 }}>
                        {option.selectedOption?.name},
                    </span>
                )
            })}
        </RenderIf>
    );
}

export function ChangeLink({ children, className = '', type = 'button', anchor = null, ...rest }) {
    return <a onClick={e => {
        e.preventDefault();
        console.log('anchor', anchor);
        if (anchor) {
            store.scrollTo(anchor);
        }
    }} type={type} className={`btn-link ${className}`} {...rest}>
        {children}
    </a>
}

export const SummaryRender = observer(({ className, showButtons = false }: { className?: string, showButtons?: boolean }) => {

    if (!store.product) return null;

    const fabricStep = store.sortedStepsFlat.find((step) => step.type === 'fabric_component');
    const frameStep = store.sortedStepsFlat.find((step) => step.type === 'select_frame');
    const mattressStep = store.sortedStepsFlat.find((step) => step.type === 'mattress');

    const wymiary = store.product.options_configuration.find((option) => option.stepType === 'radio_dimensions');
    const wymiaryStep = store.sortedStepsFlat.find((step) => step.type === 'dimensions');
    const wysokoscWezglowia = store.product.options_configuration.find((option) => option.stepType === 'select_headboard');
    const tkanina = store.product.options_configuration.find((option) => option.stepType === 'fabric_component');
    const frame = store.product.options_configuration.find((option) => option.stepType === 'select_frame');
    const select_length = store.product.options_configuration.find((option) => option.stepType === 'select_length');
    // const select_headboard_type = store.product.options_configuration.find((option) => option.stepType === 'select_headboard_type');
    const mattress = store.selectedMattress;

    const otherOptions = store.product.options_configuration.filter((option) => {
        // return true;
        return option.stepType !== 'radio_dimensions' &&
            option.stepType !== 'select_headboard' &&
            option.stepType !== 'fabric_component' &&
            option.stepType !== 'select_length' &&
            option.stepType !== 'select_frame' &&
            option.stepType !== 'select_safety_type';
        // && option.stepType !== 'select_headboard_type';
    }).filter((option) => !!option.selectedOption);

    const wymiaryName = wymiary?.selectedOption?.name || '-';
    const wysokoscWezglowiaName = wysokoscWezglowia?.selectedOption?.name || '-';
    const tkaninaName = tkanina?.selectedOption?.name || '-';
    const tkaninaColor = tkanina?.selectedOption?.color || '#000';
    const categoryName = tkanina?.selectedOption?.fabricCategoryName || '-';
    const frameName = frame?.selectedOption?.name || '-';
    const select_lengthName = select_length?.selectedOption?.name || '-';

    return (
        <>
            {/* {store.sortedSteps.map((c, index) => {
                return <React.Fragment key={index}>

                    <p className="c-h3 mt-3 mb-2">{c.name}</p>
                    <GrayBox className={className}>
                        {
                            c.components?.map((c, index) => {
                                return <div className="GrayBox__row" key={index}>
                                    <div className="GrayBox__label">
                                        {c.name}:
                                    </div>
                                    <div className="GrayBox__value">
                                        {c.selectedOption?.name || '-'}
                                    </div>
                                </div>
                            })
                        }
                    </GrayBox>
                </React.Fragment>

            })} */}

            <BoxHeader anchor={wymiaryStep.typeId} showButtons={showButtons}>
                {_t('dimensions_title')}
            </BoxHeader>
            <GrayBox className={className}>
                {wymiaryStep?.components.map((c, index) => {
                    return <div className="GrayBox__row" key={index}>
                        <div className="GrayBox__label d-flex">
                            {c.name}:
                        </div>
                        <div className="GrayBox__value">
                            {/* {wymiaryName} */}
                            {c.selectedOption?.label || c.selectedOption?.name || '-'}
                        </div>
                    </div>
                })}


            </GrayBox>


            {fabricStep ? (
                <>
                    <BoxHeader anchor={fabricStep?.typeId} showButtons={showButtons}>
                        {_t('fabric')}
                    </BoxHeader>
                    <GrayBox className={className}>
                        <div className="GrayBox__row">
                            <div className="GrayBox__label">
                                {_t('fabric_collection')}:
                            </div>
                            <div className="GrayBox__value">
                                {categoryName}
                            </div>
                        </div>
                        <div className="GrayBox__row">
                            <div className="GrayBox__label">
                                {_t('color')}:
                            </div>
                            <div className="GrayBox__value">
                                {tkaninaName} <div className="GrayBox__color" style={{ background: tkaninaColor }}></div>
                            </div>
                        </div>
                        {/* <RenderIf condition={select_headboard_type}>
                    <div className="GrayBox__row">
                        <div className="GrayBox__label">
                            Tył wezgłowia:
                        </div>
                        <div className="GrayBox__value">
                            {select_headboard_type?.selectedOption?.name || '-'}
                        </div>
                    </div>
                </RenderIf> */}
                    </GrayBox>
                </>
            ) : null}


            {frameStep ? (
                <>
                    <BoxHeader anchor={frameStep.typeId} showButtons={showButtons}>
                        {_t('frame')}
                    </BoxHeader>
                    <GrayBox className={className}>
                        <div className="GrayBox__row">
                            <div className="GrayBox__label">
                                {_t('type')}:
                            </div>
                            <div className="GrayBox__value">
                                {frameName}
                            </div>
                        </div>
                    </GrayBox>
                </>
            ) : null}



            {mattressStep ? (
                <>
                    <RenderIf condition={mattress.length > 0}>


                        <BoxHeader anchor={mattressStep.typeId} showButtons={showButtons}>
                            {_t('mattress')}
                        </BoxHeader>
                        <GrayBox className={className}>
                            <div className="GrayBox__row">
                                <div className="GrayBox__label">
                                    {_t('type')}:
                                </div>
                                <div className="GrayBox__value">
                                    {(mattress || []).map((m, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <div key={index}>{m.name}</div>
                                                <ProductSubOptions product={m} />
                                            </React.Fragment>
                                        )
                                    })}
                                </div>
                            </div>
                        </GrayBox>
                    </RenderIf>
                </>
            ) : null}


            {otherOptions.map((option, index) => {

                return <React.Fragment key={index}>

                    <BoxHeader anchor={option.step?.typeId} showButtons={showButtons}>
                        {option.stepName}
                    </BoxHeader>
                    <GrayBox className={className}>
                        <div className="GrayBox__row">

                            <div className="GrayBox__value">
                                {option.selectedOption?.label || option.selectedOption?.name || '-'}
                                <ProductSubOptions product={option.selectedOption} />
                            </div>
                        </div>
                    </GrayBox>

                </React.Fragment>
            })}
            {store.extraProdcutsByStep.map(({ step, products }, index) => (
                <React.Fragment key={index}>
                    <BoxHeader anchor={step.typeId} showButtons={showButtons}>
                        {step.name}
                    </BoxHeader>
                    <GrayBox className={className}>
                        <div className="GrayBox__row">

                            <div className="GrayBox__value">
                                {products.length > 0
                                    ? products.map((item, i) => (
                                        <React.Fragment key={i}>
                                            <div>{item.name}</div>
                                            <ProductSubOptions product={item} />
                                        </React.Fragment>
                                    ))
                                    : '-'}
                            </div>
                        </div>
                    </GrayBox>

                </React.Fragment>
            ))}
        </>
    )
})
SummaryRender.displayName = 'SummaryRender';


const SummaryModal = observer(() => {
    const [checked, setChecked] = useState(false);
    const saveProject = store.saveProject;




    return (
        <Modal
            className="no-padding modal-lg"
            onClose={e => {
                store.closeSummaryPopup();
            }}
            isOpen={store.isOpenSummaryPopup}

        >
            <div className="SummaryModal">
                <div className="row a-start g-0">
                    <div className="col-12 col-md-6 order-md-2 bg-white">
                        <div className="modal-padding">
                            <div className='d-flex a-center mt-0 c-h1 '> {_t('your_config')}</div>



                            <SummaryRender />


                        </div>

                    </div>


                    <div className="col-12 col-md-6 SummaryModal__photo-preview-col">
                        <div className="SummaryModal__photo-preview">
                            <Img src={store.renderPlainImageUrl} alt="" />
                        </div>

                    </div>
                </div>
            </div>





        </Modal>
    )
});

export default SummaryModal